var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Runner } from "../../framework/Runner";
import { setupBingAerialImagery } from "../index";
import { Matrix3, Vector3 } from "three";
import { Ellipsoid } from "../../../private/math";
import { buildFlyoverTracks } from "./buildFlyoverTracks";
/**
 *
 * @param config
 * @param initFn
 * @param modifyObject
 * @param additionalTracks Additional animation tracks
 * @param endWait The length of time to wait after completing the full path
 */
export function objectLookAt(config, initFn, modifyObject, additionalTracks = () => {
    return [];
}, endWait = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        yield Runner.run(config, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            setupBingAerialImagery(renderer);
            // Create the KML and give the modification callback its chance to alter the object
            const obj = yield initFn(renderer);
            renderer.getWorld().addObject(obj);
            if (modifyObject)
                yield modifyObject(obj);
            // Get the center cartographic point, and the bounding radius of the KML
            const center = new Vector3();
            obj.getEstimatedCenter(center);
            const centerC = Ellipsoid.WGS_84.cartographicForPosition(center).setHeight(0);
            const centerS = Ellipsoid.WGS_84.scaleToGeodeticSurface(center);
            const radius = obj.getBoundingVolume()[3];
            // Get a rotated coordinate system based on the ellipsoid normal
            const basis = new Matrix3();
            Ellipsoid.WGS_84.rotationBasisForCartographic(centerC, basis);
            // basis.invert(); // Invert to rotate out of the rotated coordinate system into world space
            const SCRATCH = new Vector3();
            function convertPoint(x, z, pRadius, result = new Vector3()) {
                result.set(x, 0, z).applyMatrix3(basis).add(centerS);
                Ellipsoid.WGS_84.scaleToGeodeticSurface(result);
                Ellipsoid.WGS_84.geodeticSurfaceNormalForPosition(result, SCRATCH).multiplyScalar(pRadius);
                return result.add(SCRATCH);
            }
            const pointA = convertPoint(radius * 3, radius * 3, radius * 3);
            const POSITIONS = [pointA, pointA, pointA];
            const FOCUSES = [centerS, centerS, centerS];
            const DURATIONS = [0, 2, 10];
            const out = buildFlyoverTracks(camera, POSITIONS, FOCUSES, DURATIONS, endWait);
            out.push(...additionalTracks());
            return out;
        }));
    });
}
